<template>
    <div class="fileContainer">
        <div class="logo-preview"><img :src="value"></div>
        <span>{{ text }}</span>
        <small v-if="subtext">{{subtext}}</small>
        <input type="file" @input="update" />
        <div class="error" v-if="errortext && tooLarge">{{errortext}}</div>
    </div>
</template>

<script>
    export default {
        name: "add",
        props : {
            errortext : String,
            subtext : String,
            text : {
                type: String,
                required : true
            },
            limit : {
                type: Number,
                default : 200000
            },
            value: String
        },
        data(){
            return {
                size : null,
                logoData : null
            }
        },
        methods : {
            update ( { target } ){
                const file = target.files[ 0 ]
                this.size = file.size

                if( !this.tooLarge ){
                    const reader = new FileReader()
                    reader.addEventListener( "load", () => {
                        this.logoData = reader.result
                        this.$emit( 'input', this.logoData )
                    }, false )
                    reader.readAsDataURL( file )
                }
            }
        },
        computed : {
            tooLarge (){
                return this.size && this.size >= this.limit
            }
        }
    }
    
</script>

<style lang="scss" scoped>
    @import "../scss/vars";
    .error {
        color: $red;
        font-weight: bold;
    }

    .logo-preview{
        width: 10rem;
        height: 10rem;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: white;
        margin-bottom: 2rem;

        img{
            display: block;
            padding: 0;
            margin: 0 auto;
        }
    }

    .fileContainer {
        padding: 1rem;
        display: block;
        text-align: center;
        background-color: #eee;
        border-radius: $radius;
        min-height: 16rem;
        margin-bottom: 1rem;
        position: relative;
        overflow: hidden;

        small{
            color: $mid-gray;
            font-size: 1.2rem;
            font-style: italic;
        }

        span{
            color: $red;
            text-align: center;
            line-height: 1rem;
            display: block;
            text-transform: uppercase;
            font-weight: 700;
        }
    }

    .fileContainer input {
        cursor: inherit;
        position: absolute;
        right: 0;
        bottom: 0;
        top: 0;
        display: block;
        width: 200%;
        height: 100%;
        color: transparent;
        text-align: right;
        cursor: pointer;  
    }
</style>